import * as yup from "yup";

export default yup.object().shape({
    password: yup.string().required("Le champ mot de passe est obligatoire"),
    confirmPassword: yup.string().required("Le champ mot de passe est obligatoire"),
})
